import { create } from 'zustand'
import { AdminSettings } from '../admin';
import { shallow } from 'zustand/shallow';

type AdminStore = {
  isAdminUser: boolean | undefined;
  adminSettings: AdminSettings | undefined;

  setIsAdminUser: (isAdminUser: AdminStore["isAdminUser"]) => void;
  setAdminSettings: (adminSettings: AdminStore["adminSettings"]) => void;
}

export const useAdminStore = create<AdminStore>((set, get) => ({
  isAdminUser: undefined,
  adminSettings: undefined,
  setIsAdminUser: (isAdminUser) => {
    if (get().isAdminUser === isAdminUser) return;
    set({ isAdminUser });
  },
  setAdminSettings: (adminSettings) => {
    if (shallow(get().adminSettings, adminSettings)) return;
    set({ adminSettings });
  },
}));


